const unlockedFeaturesFullNames =[
  {featureName: "moneyBuilder", fullName: "Money Builder", imgSrc: "moneyBuilder.jpg"},
  {featureName: "funStuff", fullName: "Fun Stuff", imgSrc: "funStuff.jpg"},
  {featureName: "creditCard", fullName: "Credit Card", imgSrc: "creditCard.png"},
  {featureName: "timeWizard", fullName: "Time Wizard", imgSrc: "timeWizard.png"},

];

export default unlockedFeaturesFullNames;